import {makeSplitPoint} from 'plugins/react'

export const LoginForm = makeSplitPoint(() => import('./LoginForm'))
export const LoginModal = makeSplitPoint(() => import('./LoginModal'))
export const ResetForm = makeSplitPoint(() => import('./ResetForm'))
